<script>
// 工单状态等badge显示

import {WorkOrderStatus, WorkOrderPriority, WorkOrderWarrantyStatus} from "@/config/common";
import {getOptionLabel} from "@/helpers/common";
import {
  isWorkOrderToBeConfirmed,
  isWorkOrderUnderConstruction,
  isWorkOrderToBeReassigned,
  isWorkOrderAwaitingSignature
} from "@/views/work-order/wo-status-op";

export default {
  props: {
    // 自定义class
    customClass: {
      type: String,
      default: ''
    },
    // 自定义style
    customStyle: {
      type: String,
      default: ''
    },
    // 状态
    value: {
      type: [String, Number]
    },
    // 字段
    fieldName: {
      type: String
    },
    isReassign: {
      type: [Boolean],
      default: null
    },
    // 工单数据
    woData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      WorkOrderStatus,
      WorkOrderPriority,
      WorkOrderWarrantyStatus,
      statusColors: [
        'badge badge-soft-warning',
        'badge badge-soft-info',
        'badge badge-soft-success',
        'badge badge-soft-dark',
      ],
      priorityColors: [
        'badge bg-success',
        'badge text-bg-warning',
        'badge text-bg-danger'
      ],
      warrantyColors: [
        'badge text-bg-success',
        'badge text-bg-warning',
      ],
    }
  },
  computed: {
    allClass() {
      let currentColor = 'badge-soft-dark'
      if (this.fieldName == 'status') {
        currentColor = this.statusColors[parseInt(this.value) - 1]
        if (isWorkOrderToBeReassigned(this.woData)) {
          currentColor = 'badge badge-soft-danger'
        }
        if (isWorkOrderToBeConfirmed(this.woData)) {
          currentColor = 'badge badge-soft-primary'
        }
        if (isWorkOrderUnderConstruction(this.woData)) {
          currentColor = 'badge badge-soft-secondary'
        }
        if(isWorkOrderAwaitingSignature(this.woData)){
          currentColor = 'badge badge-soft-dark'
        }
      } else if (this.fieldName == 'priority') {
        currentColor = this.priorityColors[parseInt(this.value) - 1]
      } else if (this.fieldName == 'warranty_status') {
        currentColor = this.warrantyColors[parseInt(this.value) - 1]
      }
      return currentColor + ' ' + this.customClass
    },
    valueTxt() {
      let txt = ''
      if (this.fieldName == 'status') {
        // if (this.woData.status_txt) {
        //   return this.woData.status_txt
        // }
        if (isWorkOrderToBeReassigned(this.woData)) {
          return this.$t('page.work-order.status.reassign')
        }
        if (isWorkOrderToBeConfirmed(this.woData)) {
          return this.$t('page.work-order.status.unconfirmed')
        }
        if (isWorkOrderUnderConstruction(this.woData)) {
          return this.$t('page.work-order.status.under-construction')
        }
        if(isWorkOrderAwaitingSignature(this.woData)){
          return this.$t('page.work-order.status.awaiting-signature')
        }
        txt = this.getOptionLabel(this.WorkOrderStatus, parseInt(this.value))
      } else if (this.fieldName == 'priority') {
        txt = this.getOptionLabel(this.WorkOrderPriority, parseInt(this.value))
      } else if (this.fieldName == 'warranty_status') {
        txt = this.getOptionLabel(this.WorkOrderWarrantyStatus, parseInt(this.value))
      }
      return txt
    }
  },
  methods: {
    getOptionLabel,
  }
}
</script>
<template>
  <span :class="allClass" :style="customStyle">{{ valueTxt }}</span>
</template>
